import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Nav, NavItem, Modal, Tab, Row, Col } from "react-bootstrap";
import Moment from "moment";
import { Breadcrumb } from "components/breadcrumb/breadcrumb";

import * as LotActionType from "../constants";
import { AppSettings } from "../../constants";

import EditLot from "./lot-edit";
import ManageRFSLot from "./lot-view-rfs-list";
import LotDocument from "./lot-view-document";
import OwnershipInfo from "./lot-view-ownership-info";

import Translate from "components/translate";
import ManageNotes from "../Components/ManageNotes";
import MangeLotLocations from "./lot-view-locations";

import emptyImage from "assets/img/empty-images.svg";

const STATIC_LOT_INVENTORY = [
  { id: "1", name: "Kitchen Cabinet", model: "KC-2024" },
  { id: "2", name: "HVAC Unit", model: "HVAC-500" },
  { id: "3", name: "Water Heater", model: "WH-40G" },
  { id: "4", name: "Garage Door Opener", model: "GD-16X7" },
  { id: "5", name: "Fireplace Insert", model: "FP-300" },
  { id: "6", name: "Hardwood Flooring", model: "HF-OAK" },
];

class LotDetail extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    dispatch: PropTypes.func,
    LotStore: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      lotId: this.props.match.params.lotId,
      isViewMode: true,
      isDisplayModalConfirm: false,
      hoveredInventoryId: null,
    };
  }

  componentDidMount() {
    this.onBindingLotDetail();
  }

  // componentWillUnmount() {
  //   this.props.dispatch({
  //     type: LotActionType.RESET_LOT_PROFILE
  //   });
  // }

  onBindingLotDetail = () => {
    console.log("onBindingLotDetail");
    if (AppSettings.clientTypeValue === "Homeowner") {
      if (!this.props.LotStore.HomeownerLots.length) {
        this.onGetBuilderProfile();
      } else {
        const lotFound = this.props.LotStore.HomeownerLots.find(
          (item) => item.lot.id === this.state.lotId,
        );
        if (lotFound) {
          this.onBindHomeownerLotDetail(lotFound.builderProfile);
        } else {
          this.onGetBuilderProfile();
        }
      }
    } else {
      this.props.dispatch({
        type: LotActionType.GET_LOT_BY_ID_ASYNC,
        params: this.state.lotId,
      });
    }
  };

  onGetBuilderProfile = () => {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
      params: { lotId: this.state.lotId },
      callbackGetBuilderProfile: (builderProfile) => {
        this.onBindHomeownerLotDetail(builderProfile);
      },
    });
  };

  onBindHomeownerLotDetail = (builderProfile) => {
    console.log("onBindHomeownerLotDetail");
    /**
     * BuilderProfile get from homeowner portal by server
     */
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_DETAIL_ASYNC,
      params: {
        endpoint: builderProfile.lotDetailEndpoint,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken,
        },
      },
      callback: (data) => {
        console.log("Lot details", data);
      },
    });
  };

  onCheckHomeownerOrTenancy = (lotProfileId) => {
    let isHomeowner = true;
    if (AppSettings.clientTypeValue === "Homeowner") {
      const lotFound = this.props.LotStore.HomeownerLots.find(
        (item) => item.lot.id === lotProfileId,
      );
      if (lotFound && !lotFound.owner) {
        isHomeowner = false;
      }
    }
    return isHomeowner;
  };

  onCheckHasHORFS = () => {
    if (AppSettings.clientTypeValue !== "Homeowner") {
      return true;
    }
    const hasHORFSParam = new URLSearchParams(this.props.location.search).get(
      "hasHORFS",
    );
    if (hasHORFSParam !== null) {
      return hasHORFSParam === "true";
    }
    /**
     * Deep link / refresh without the param: fall back to the lot record
     */
    const lotFound = this.props.LotStore.HomeownerLots.find(
      (item) => item.lot.id === this.state.lotId,
    );
    return !!(lotFound && (lotFound.hasHORFS || lotFound.HasHORFS));
  };

  onToggleViewMode = () => {
    this.setState({
      isViewMode: !this.state.isViewMode,
    });
  };

  onCustomAction = () => {
    if (this.state.isViewMode) {
      this.props.history.push("/lots");
    } else {
      this.setState({ isDisplayModalConfirm: true });
    }
  };

  onLinkToLot = () => {
    this.props.history.push("/lots");
  };

  handleClose = () => {
    this.setState({ isDisplayModalConfirm: false });
  };

  onSelectTab = (selectedKey) => {
    const queryParams = new URLSearchParams(this.props.location.search);
    if (queryParams.get("active") !== selectedKey) {
      // Update in place so other params (hasHORFS, ...) survive the tab change
      queryParams.set("active", selectedKey);
      this.props.history.push({
        pathname: this.props.location.pathname,
        search: `?${queryParams.toString()}`,
      });
    }
  };

  renderLotInfoDetail = (data) => {
    if (data) {
      return <strong>{data}</strong>;
    }
    return <span style={{ opacity: ".5" }}>(Not specified)</span>;
  };

  renderLotCOE = (coe) => {
    if (coe) {
      return <strong>{Moment(coe).format("MM/DD/YYYY")}</strong>;
    }
    return <span style={{ opacity: ".5" }}>(Not specified)</span>;
  };

  renderLotInventory = () => {
    const { hoveredInventoryId } = this.state;
    return (
      <div className="manage-inventory-items-container container-fluid">
        <div className="row">
          <div style={{ marginBottom: 15 }} className="col-md-12 col-xs-12">
            <button
              style={{ float: "right", marginLeft: 20 }}
              className="btn btn-primary btn-siteone"
            >
              <span className="fa fa-plus icon" /> NEW
            </button>
            <button
              style={{ float: "right" }}
              className="btn btn-default btn-outline"
            >
              <span className="glyphicon glyphicon-import" /> IMPORT
            </button>
          </div>
        </div>
        <div className="row">
          <div
            className="group-function-inventory-item col-md-9 col-xs-6"
            style={{ paddingLeft: 0, paddingRight: 0 }}
          >
            <div className="groupby-inventory-item">
              <span className="group-by-category-items">Group by</span>
            </div>
          </div>
          <div className="col-md-3 col-xs-6">
            <div
              className="box-search"
              style={{ margin: 0, transform: "translateY(5px)" }}
            >
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by name"
                  readOnly
                />
                <span className="input-group-btn">
                  <button
                    style={{
                      padding: "4px 10px",
                      fontSize: 16,
                      backgroundColor: "#ececec",
                      border: "0.5px solid #d8d8d8",
                      height: 40,
                    }}
                    className="btn btn-secondary"
                  >
                    <span className="fa fa-search" aria-hidden="true" />
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xs-12">
            <h4
              className="title"
              style={{ marginTop: 15, marginBottom: 5, fontWeight: "bold" }}
            >
              Inventory
            </h4>
          </div>
          {STATIC_LOT_INVENTORY.map((item) => (
            <div
              key={item.id}
              style={{ marginBottom: 15 }}
              className="col-xs-4 col-lg-3"
            >
              <div className="category-list-items">
                <div
                  style={{ marginBottom: 10 }}
                  className="category-list-item-wrapper"
                >
                  <div
                    className="document-thumbnail-wrapper thumbnail-wrapper-item"
                    onMouseEnter={() =>
                      this.setState({ hoveredInventoryId: item.id })
                    }
                    onMouseLeave={() =>
                      this.setState({ hoveredInventoryId: null })
                    }
                  >
                    <img
                      style={{
                        width: "100%",
                        height: 170,
                        objectFit: "contain",
                      }}
                      src={emptyImage}
                      alt={item.name}
                    />
                    {hoveredInventoryId === item.id && (
                      <div className="document-fade" />
                    )}
                  </div>
                </div>
                <div
                  style={{ display: "grid", justifyContent: "left" }}
                  className="category-list-items-project-name"
                >
                  <div className="category-name col-md-12 col-sm-12">
                    <div className="over-flow-text">{item.name}</div>
                    <div
                      className="over-flow-text"
                      style={{ color: "lightgray" }}
                    >
                      Model #{item.model}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  render() {
    const { LotProfile } = this.props.LotStore;
    if (LotProfile && LotProfile.id) {
      const breadcrumbs = [
        {
          title: <Translate translateKey="lot" plurals capitalize />,
          url: "/lots",
          onCustomAction: this.onCustomAction,
        },
        { title: LotProfile.name || "", url: "" },
      ];
      const queryParams = new URLSearchParams(this.props.location.search);
      let active = queryParams.get("active") ? queryParams.get("active") : "lot-info";
      /**
       * The requests-for-service tab is hidden when the lot has no HORFS,
       * so don't leave the page pointing at a tab that no longer renders
       */
      if (active === "request-for-service" && !this.onCheckHasHORFS()) {
        active = "lot-info";
      }
      return (
        <div
          style={{
            margin: AppSettings.clientTypeValue == "Homeowner" ? "30px" : "",
          }}
        >
          <div
            className="page-title"
            style={
              this.props.LotStore.HomeownerLots.length === 1
                ? { marginBottom: 30 }
                : {}
            }
          >
            <h2>{LotProfile.name + " - " + LotProfile.streetAddress}</h2>
          </div>

          {(AppSettings.clientTypeValue !== "Homeowner" ||
            this.props.LotStore.HomeownerLots.length > 1) && (
            <Breadcrumb breadcrumbs={breadcrumbs} />
          )}

          <div className="wrapper box-form-siteone">
            <Tab.Container id="lot-detail-tab" defaultActiveKey={active}>
              <Row className="clearfix">
                <Col sm={12}>
                  <Nav
                    className="lot-info-tab-ul"
                    bsStyle="tabs"
                    onSelect={this.onSelectTab}
                  >
                    <NavItem eventKey="lot-info">
                      <Translate translateKey="lot" capitalize /> info
                    </NavItem>
                    {this.onCheckHomeownerOrTenancy(LotProfile.id) && (
                      <NavItem eventKey="ownership-info">
                        Ownership info
                      </NavItem>
                    )}
                    {this.onCheckHasHORFS() && (
                      <NavItem eventKey="request-for-service">
                        Requests for service
                      </NavItem>
                    )}
                    {this.onCheckHomeownerOrTenancy(LotProfile.id) && (
                      <NavItem eventKey="location">Locations</NavItem>
                    )}
                    {this.onCheckHomeownerOrTenancy(LotProfile.id) &&
                      AppSettings.clientTypeValue === "Builder" && (
                        <NavItem eventKey="notes">Notes</NavItem>
                      )}
                    {this.onCheckHomeownerOrTenancy(LotProfile.id) && (
                      <NavItem eventKey="documents">Documents</NavItem>
                    )}
                    <NavItem eventKey="lot-inventory">Lot inventory</NavItem>
                  </Nav>
                </Col>
                <Col sm={12}>
                  <Tab.Content animation>
                    <Tab.Pane eventKey="lot-info">
                      {this.state.isViewMode ? (
                        <div className="lot-info-content lot-info-detail">
                          <div className="row">
                            <div className="form-group col-sm-8">
                              <label className="lot-info-label">
                                <Translate
                                  translateKey="project"
                                  plurals
                                  capitalize
                                />
                              </label>
                              <span className="lot-info-value">
                                {this.renderLotInfoDetail(
                                  LotProfile.projectName,
                                )}
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="form-group col-sm-8">
                              <label className="lot-info-label">Location</label>
                              <span className="lot-info-value">
                                {this.renderLotInfoDetail(LotProfile.location)}
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="form-group col-sm-8">
                              <label className="lot-info-label">
                                <Translate translateKey="phase" capitalize />
                              </label>
                              <span className="lot-info-value">
                                {this.renderLotInfoDetail(LotProfile.phaseName)}
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="form-group col-sm-8">
                              <label className="lot-info-label">Plan</label>
                              <span className="lot-info-value">
                                {this.renderLotInfoDetail(LotProfile.modelName)}
                              </span>
                            </div>
                          </div>
                          {AppSettings.clientTypeValue !== "Homeowner" ? (
                            <div className="row">
                              <div className="form-group col-sm-8">
                                <label className="lot-info-label">
                                  Cost center/account
                                </label>
                                <span className="lot-info-value">
                                  {this.renderLotInfoDetail(
                                    LotProfile.projectCode,
                                  )}
                                </span>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {AppSettings.clientTypeValue !== "Homeowner" ? (
                            <div className="row">
                              <div className="form-group col-sm-8">
                                <label className="lot-info-label">
                                  Insurance policy
                                </label>
                                <span className="lot-info-value">
                                  {this.renderLotInfoDetail(
                                    LotProfile.insurancePolicy
                                      ? LotProfile.insurancePolicy.name
                                      : null,
                                  )}
                                </span>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          <div className="row">
                            <div className="form-group col-sm-8">
                              <label className="lot-info-label">
                                <Translate translateKey="lot" capitalize />{" "}
                                number
                              </label>
                              <span className="lot-info-value">
                                {this.renderLotInfoDetail(LotProfile.name)}
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="form-group col-sm-8">
                              <label className="lot-info-label">
                                Street address
                              </label>
                              <span className="lot-info-value">
                                {this.renderLotInfoDetail(
                                  LotProfile.streetAddress,
                                )}
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="form-group col-sm-8">
                              <label className="lot-info-label">
                                Original COE
                              </label>
                              <span className="lot-info-value">
                                {this.renderLotCOE(LotProfile.coe)}
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="form-group col-sm-8">
                              <label className="lot-info-label">Note</label>
                              <span className="lot-info-value">
                                {this.renderLotInfoDetail(LotProfile.note)}
                              </span>
                            </div>
                          </div>
                          {AppSettings.clientTypeValue !== "Homeowner" && (
                            <div className="row">
                              <div className="form-group col-sm-8">
                                <div className="col-sm-12">
                                  <button
                                    className="btn btn-primary btn-info btn-siteone"
                                    onClick={this.onToggleViewMode}
                                  >
                                    Edit
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <EditLot
                          onToggleViewMode={this.onToggleViewMode}
                          LotProfile={LotProfile}
                        />
                      )}
                    </Tab.Pane>
                    {this.onCheckHomeownerOrTenancy(LotProfile.id) && (
                      <Tab.Pane eventKey="ownership-info">
                        <OwnershipInfo
                          location={this.props.location}
                          history={this.props.history}
                        />
                      </Tab.Pane>
                    )}
                    {this.onCheckHasHORFS() && (
                      <Tab.Pane eventKey="request-for-service">
                        {active === "request-for-service" && (
                          <ManageRFSLot
                            location={this.props.location}
                            history={this.props.history}
                            lotId={this.state.lotId}
                          />
                        )}
                      </Tab.Pane>
                    )}

                    {this.onCheckHomeownerOrTenancy(LotProfile.id) && (
                      <Tab.Pane eventKey="location">
                        {active === "location" && (
                          <MangeLotLocations
                            dispatch={this.props.dispatch}
                            history={this.props.history}
                            lotId={this.state.lotId}
                          />
                        )}
                      </Tab.Pane>
                    )}
                    {this.onCheckHomeownerOrTenancy(LotProfile.id) && (
                      <Tab.Pane eventKey="notes">
                        {AppSettings.clientTypeValue === "Builder" && (
                          <ManageNotes
                            dispatch={this.props.dispatch}
                            history={this.props.history}
                            lotId={this.state.lotId}
                          />
                        )}
                      </Tab.Pane>
                    )}
                    {this.onCheckHomeownerOrTenancy(LotProfile.id) && (
                      <Tab.Pane eventKey="documents">
                        {active === "documents" && (
                          <LotDocument
                            location={this.props.location}
                            history={this.props.history}
                            lotId={this.state.lotId}
                          />
                        )}
                      </Tab.Pane>
                    )}
                    <Tab.Pane eventKey="lot-inventory">
                      {this.renderLotInventory()}
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </div>

          <Modal
            show={this.state.isDisplayModalConfirm}
            onHide={this.handleClose}
            style={{ top: "20%" }}
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirm</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>All information will be discarded. Continue?</p>
            </Modal.Body>
            <Modal.Footer>
              <div className="text-right">
                <button
                  className="btn btn-primary btn-info btn-siteone"
                  onClick={this.handleClose}
                >
                  No
                </button>
                <button
                  className="btn btn-primary btn-siteone-default"
                  style={{ marginLeft: 10 }}
                  onClick={this.onLinkToLot}
                >
                  Yes
                </button>
              </div>
            </Modal.Footer>
          </Modal>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    LotStore: state.LotStore,
  };
};

export default connect(mapStateToProps)(LotDetail);



// WEBPACK FOOTER //
// ./src/Lots/Containers/lot-view.js